<div class="fullwidth">
  <div class="top" [class.gradient-top]="colors.primaryColor2" #top>
    <div class="headline">
      <div class="backButtonWrapper" *ngIf="activeCollection.partOfCollection">
        <button mat-icon-button routerLink="..">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="overline">{{ activeCollection.overline }}</h1>
      </div>
      <h1 *ngIf="!activeCollection.partOfCollection" class="overline">{{ activeCollection.overline }}</h1>
      <h1>{{ activeCollection.headline }}</h1>
      <p [innerHtml]="activeCollection.text | safeHTML"></p>
    </div>
    <mat-form-field appearance="outline" class="searchBooth" *ngIf="!mobile && onlyExpos">
      <mat-chip-list #chipList>
        <mat-chip *ngFor="let tag of searchedTags" selectable="true" removable="true" (removed)="removeTagFilter(tag)">
          {{ tag }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input
          #tagsInput
          [placeholder]="searchText"
          (keyup)="searchExpos(true)"
          [formControl]="tagsCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          (matChipInputTokenEnd)="addTagFilter($event)"
        />
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTagOption($event)">
        <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
          {{ tag }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div *ngIf="loaded">
    <div class="collection-expos bottom" *ngIf="searchValue.trim().length === 0 && searchedTags.length === 0">
      <div class="collection-expo card" *ngFor="let room of activeCollection.rooms; let i = index">
        <img *ngIf="room.img && mobile" [src]="room.img | safe" />
        <img
          *ngIf="room.img && !mobile"
          (click)="enterRoom(room)"
          [src]="room.img | safe"
          [matTooltip]="activeCollection.captionEnter"
        />
        <h2 class="expo-title" (click)="enterRoom(room)" [matTooltip]="activeCollection.captionEnter">{{ room.name }}</h2>
        <p
          id="{{ 'description' + i }}"
          *ngIf="room.description"
          [class.showDesc]="i == expanded"
          [innerHtml]="room.description | safeHTML"
        ></p>
        <!-- Important, gives the expo name appropriate margin if no description is present -->
        <p *ngIf="!room.description"></p>
        <button
          mat-button
          class="showMore"
          *ngIf="mobile && !(i == expanded) && document.getElementById('description' + i)?.offsetHeight >= 100"
          (click)="expanded = i"
        >
          <mat-icon>expand_more</mat-icon>
        </button>
        <button mat-button class="showMore" *ngIf="mobile && i == expanded" (click)="expanded = -1">
          <mat-icon>expand_less</mat-icon>
        </button>
        <button id="collectionEnter" class="enterButton" (click)="enterRoom(room)">{{ activeCollection.captionEnter }}</button>
      </div>
    </div>
    <div class="collection-expos bottom" style="flex-direction: column;">
      <div *ngFor="let tradefairBooths of filteredBooths" class="filteredBoothsWrapper">
        <h1 style="font-weight: bold; color: black;">{{ tradefairBooths.tradefairName }}</h1>
        <div style="display: flex; flex-wrap: wrap; gap: 16px;">
          <div *ngFor="let booth of tradefairBooths.booths" class="mobile-wrapper">
            <div class="innerWrapper">
              <div class="innerInnerWrapper" (click)="openBooth(booth)">
                <h1 *ngIf="booth.settings.enableName || booth.settings.enableName === undefined">
                  {{ booth.settings.name }}
                </h1>
                <img [src]="booth.settings.sliderImg | safe" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="stylingHelper" style="width: calc(50vw - 40px + 16px);"></div>
      <button *ngIf="mobile" (click)="scrollToTop(top)" style="margin-left: auto;margin-top: 16px" mat-mini-fab aria-label="Back to top button">
        <mat-icon>arrow_upward</mat-icon>
      </button>
    </div>
  </div>
</div>
